import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { pagination as pageConstants } from 'src/constants';
import { getPaginationConfig } from 'src/utils';

import Pagination from './PaginationComponent';

const PaginationContainer = ({
  setPagination,
  pagination,
  fetchNewResources,
  resourcesLength,
}) => {
  useEffect(() => {
    if (resourcesLength && resourcesLength !== pagination.totalItems) {
      const newPagination = getPaginationConfig(
        pageConstants.INITIAL_PAGE,
        pagination.pageInterval,
        resourcesLength
      );

      setPagination(newPagination);
    }
  }, [
    pagination.pageInterval,
    pagination.totalItems,
    resourcesLength,
    setPagination,
  ]);

  const handlePagination = (paginationConfig) => {
    let newPagination;

    if (pagination.currentPage !== paginationConfig.currentPage) {
      newPagination = getPaginationConfig(
        paginationConfig.currentPage,
        paginationConfig.pageInterval,
        resourcesLength
      );
    } else if (pagination.pageInterval !== paginationConfig.pageInterval) {
      // if interval changes reset to initial page
      newPagination = getPaginationConfig(
        pageConstants.INITIAL_PAGE,
        paginationConfig.pageInterval,
        resourcesLength
      );
    }

    if (newPagination) {
      setPagination(newPagination);
      fetchNewResources(newPagination);
    }
  };

  if (!resourcesLength) {
    return null;
  }

  return (
    <Pagination handlePagination={handlePagination} pagination={pagination} />
  );
};

PaginationContainer.propTypes = {
  pagination: PropTypes.object,
  resourcesLength: PropTypes.number,
  fetchNewResources: PropTypes.func,
  setPagination: PropTypes.func,
};

export default PaginationContainer;
